class Glossary {
  manageRoute = () => {
    const { hash } = window.location;

    if (hash && this.hashMatches(hash)) {
      this.scrollPageTo(hash);
    }
  };

  scrollPageTo = (hash) => {
    const glossaryPartList = document.querySelector(hash);

    if (!glossaryPartList) {
      return;
    }

    const glossaryPartListTop = glossaryPartList.offsetTop;

    requestAnimationFrame(() => {
      try {
        window.scrollTo({
          top: glossaryPartListTop,
          left: 0,
          behavior: 'smooth',
        });
      } catch (er) {
        window.scrollTo(0, -32);
      }
    });
  };

  updateHistory = (hash) => {
    window.history.pushState({}, '', hash);
  };

  constructor() {
    this.selectors = {
      letter: '.js-glossary-letter',
    };

    this.DOM = {
      letters: document.querySelectorAll(this.selectors.letter),
    };

    if (!this.DOM.letters.length) {
      return;
    }

    this.init();
  }

  init() {
    this.addListeners();
  }

  addListeners() {
    this.DOM.letters.forEach((letter) => {
      letter.addEventListener('click', (e) => {
        const { hash } = e.currentTarget;

        e.preventDefault();

        this.updateHistory(hash);
        this.scrollPageTo(hash);
      });
    });
    window.addEventListener('load', this.manageRoute);
    window.addEventListener('popstate', this.manageRoute);
  }

  hashMatches(hash) {
    return Array.from(this.DOM.letters).some((letter) => letter.hash === hash);
  }
}

export default new Glossary();
